/* eslint-disable react/prop-types */
import React from 'react';
import InputFile from '../../components/input-file/InputFile';
import CardLayout from '../../components/cards/CardLayout';
import CardBody from '../../components/cards/CardBody';
import CardItem from '../../components/cards/CardItem';
import CardFooter from '../../components/cards/CardFooter';
import Button from '../../components/button/Button';

const CardEditPicture = ({
    pictureType,
    onChangeFile,
    openDelete,
    closeEdit
}) => {
    return (
        <CardLayout title={`Edit ${pictureType} picture`}>
            <CardBody component="div" variant="start" padding={1}>
                <InputFile onChange={onChangeFile}>
                    <CardItem ico="upload">Upload photo</CardItem>
                </InputFile>
            </CardBody>
            <CardBody component="hr" variant="center" />
            <CardBody component="div" variant="start" padding={1}>
                <CardItem onClick={openDelete} ico="trash">
                    Delete photo
                </CardItem>
            </CardBody>
            <CardFooter justified="end" position="right">
                <Button
                    onClick={closeEdit}
                    text="Cancel"
                    classs="btnOutlineMain"
                    fontSize="13px"
                />
            </CardFooter>
        </CardLayout>
    );
};

export default CardEditPicture;
